const reducer = (state = 'All', action) =>{
    switch(action.type){
        case "setCompanyTypeFilter2": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  